export default __webpack_public_path__ + "static/media/Bandit's Boots of World's Edge.3476c650.jpg";